export default class AvatarUtils {
    private static colors = [
        '#007bff', //blue			
        '#6610f2', //indigo			
        '#6f42c1', //purple			
        '#e83e8c', //pink			
        '#dc3545', //red				
        '#fd7e14', //orange			
        '#ffc107', //yellow			
        '#28a745', //green			
        '#20c997', //teal			
        '#17a2b8', //cyan			
        '#80808F', //gray			
        '#1B283F', //gray-dark		
        '#3699FF', //primary			
        '#E5EAEE', //secondary		
        '#1BC5BD', //success			
        '#8950FC', //info			
        '#FFA800', //warning			
        '#F64E60', //danger			
        '#212121', //dark			
        '#464E5F' //dark-75			
    ];

    public static getUserInitials(name: string) {
        if (name) {
            const parts = name.split(' ');
            if (parts.length >= 2) {
                return parts[0][0] + parts[1][0];
            }
            else {
                return parts[0][0];
            }
        }

        return null;
    }

    public static getColorFromText(text: string) {
        return this.colors[this.getNumberFromText(text) % this.colors.length]
    }

    private static getNumberFromText(text: string) {
        const charCodes = text
            .split('')
            .map(char => char.charCodeAt(0))
            .join('');

        return parseInt(charCodes, 10);
    }
}